var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('box-chart',{attrs:{"title":"Offers","data":_vm.data},on:{"cleanUp":_vm.cleanUp,"draw":_vm.draw}},[_c('div',{staticClass:"w-full"},[_c('canvas',{ref:"chart"})])])}
var staticRenderFns = []

export { render, staticRenderFns }